import script from "./AccountPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=c552df22&lang=scss"

const __exports__ = script;

export default __exports__